import { Adendo } from './../adendo/adendo';
import { Padrao } from '../generic/padrao';
import { Manuais } from '../documento/manuais';
import { Fabricante } from '../estoque/fabricante';
import { FatorMoeda } from '../geral/fatorMoeda';


export class ModeloAeronave extends Padrao{

    override idTab = 152;

    adendo: Adendo | null = new Adendo();
    fabricante: Fabricante | null = new Fabricante();
    manuais: Manuais | null = new Manuais();
    fatorMoeda: FatorMoeda = new FatorMoeda();
    tipo: string;
    modelo: string;
    obs: string;
}
